
import { formatDistanceToNow } from "date-fns";
import { Voucher } from "@/types/voucher";
import { Badge } from "@/components/ui/badge";

interface VoucherCardProps {
  voucher: Voucher;
  onClick: () => void;
}

export function VoucherCard({ voucher, onClick }: VoucherCardProps) {
  const expiresIn = formatDistanceToNow(new Date(voucher.expiresAt), { addSuffix: true });
  
  return (
    <div 
      className="bg-gray-900 rounded-lg p-4 cursor-pointer hover:bg-gray-800 transition-colors"
      onClick={onClick}
    >
      <div className="flex items-start gap-3">
        <div 
          className="w-16 h-16 rounded bg-gray-800 flex-shrink-0"
          style={{
            backgroundImage: voucher.image ? `url(${voucher.image})` : undefined,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-start mb-1">
            <h3 className="font-semibold text-[#FFFCF3] truncate">{voucher.title}</h3>
            
            {voucher.isRedeemed ? (
              <Badge variant="outline" className="bg-gray-800 text-gray-400">
                Redeemed
              </Badge>
            ) : (
              <Badge variant="outline" className="bg-[#089BDF]/10 text-[#089BDF] border-[#089BDF]/30">
                Active
              </Badge>
            )}
          </div>
          
          <p className="text-sm text-gray-400 truncate">{voucher.venue.name}</p>
          <p className="text-xs text-gray-500 mt-1">Expires {expiresIn}</p>
        </div>
      </div>
    </div>
  );
}
